import { createContext } from "react";

export const CreateNoteContext = createContext((enquiryId: number) => {});
